export default __webpack_public_path__ + "static/media/csango10-13kerulet-elado-lakasok-2.bda5680b.webp";